import { BrowseCategorySection, BrowseCategoryItem } from '../../../types/peer-analyser'
import RenderHTML from '../../ui-components/RenderHTML'

interface CategoryItemProps {
  category: BrowseCategoryItem
  isLast: boolean
  onCategoryClick?: (categoryId: string) => void
}

function CategoryItem({ category, isLast, onCategoryClick }: CategoryItemProps) {
  if (!category?.id) return null

  const IconComponent = category?.Icon

  if (!IconComponent) return null

  return (
    <div
      id={`category-${category.id}`}
      data-category-id={category.id}
      role='button'
      tabIndex={0}
      className='flex items-center pl-5 cursor-pointer hover:bg-gray-50 active:bg-gray-100 transition-colors focus:outline-none '
      onClick={() => {
        if (category?.id) {
          onCategoryClick?.(category.id)
        }
      }}
    >
      <div className='w-[24px] h-[24px] mr-[22px] flex items-center justify-center flex-shrink-0'>
        <IconComponent className='w-full h-full object-contain' />
      </div>
      <div className={`flex-1 min-w-0 flex items-center ${isLast ? '' : 'border-b-2 border-[#F0F4F7]'} py-4 pr-5`}>
        <div className='flex-1 min-w-0'>
          {category.label && <div className='text-[#232323] text-[15px] font-medium mb-1'>{category.label}</div>}
          {category.description && <div className='text-[#7c7e80] text-[13px]'>{category.description}</div>}
        </div>
        <div className='ml-3 flex-shrink-0'>
          <RenderHTML innerHTMLText={RightArrowIcon} />
        </div>
      </div>
    </div>
  )
}

const RightArrowIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M13.4759 5.7463L7.77306 0.290586C7.67315 0.195059 7.5555 0.120259 7.42684 0.0704584C7.29818 0.0206575 7.16103 -0.00316942 7.02322 0.00033788C6.8854 0.00384518 6.74963 0.0346181 6.62364 0.0908995C6.49765 0.147181 6.38392 0.227869 6.28893 0.328356C6.0971 0.531299 5.99329 0.80257 6.00034 1.08249C6.00738 1.36241 6.1247 1.62806 6.32649 1.82098L11.4896 6.7521C11.5239 6.78466 11.5512 6.82391 11.5699 6.86745C11.5885 6.91099 11.5981 6.9579 11.5981 7.00531C11.5981 7.05271 11.5885 7.09962 11.5699 7.14316C11.5512 7.1867 11.5239 7.22595 11.4896 7.25851L6.32649 12.1896C6.12581 12.3813 6.00903 12.6452 6.00186 12.9234C5.99469 13.2016 6.0977 13.4713 6.28824 13.6732C6.47877 13.875 6.74123 13.9924 7.01786 13.9996C7.29449 14.0069 7.56264 13.9033 7.76333 13.7116L13.4898 8.24193C13.6528 8.07766 13.7817 7.88256 13.8693 7.66789C13.9568 7.45322 14.0013 7.22323 14 6.9912C13.9987 6.75917 13.9517 6.5297 13.8618 6.31603C13.7718 6.10236 13.6407 5.90872 13.4759 5.7463Z" fill="#8E9393"/>
</svg>`

interface CategorySectionProps {
  section: BrowseCategorySection
  onCategoryClick?: (categoryId: string) => void
}

export default function CategorySection({ section, onCategoryClick }: CategorySectionProps) {
  return (
    <div className='pt-5 pb-2'>
      {section.title && <h3 className='text-[#8E9393] text-[13px] font-[400] pb-1 px-5'>{section.title}</h3>}
      <div className='space-y-0'>
        {section.categories?.map((category, idx) => (
          <CategoryItem
            key={category?.id || idx}
            isLast={idx === (section?.categories?.length ?? 0) - 1}
            category={category}
            onCategoryClick={onCategoryClick}
          />
        ))}
      </div>
    </div>
  )
}
